import { h } from '../../utils/dom.js';
import { t } from '../../i18n/index.js';

export function ErrorState({ onRetry } = {}) {
  return h('div', { class: 'state-block state-error' },
    h('p', {}, t('notAvailableYet')),
    h('span', { class: 'state-note' }, t('notAvailableDesc')),
    onRetry ? h('button', { class: 'btn-outline', onclick: onRetry }, t('retry')) : null,
  );
}
